import { Box, Button, Card, Grid, TableCell, TableContainer, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useHistory, useParams } from 'react-router';
import { useState } from 'react';
import api from "../../../components/services/api";
import Swal from 'sweetalert2';

export default function Plan() {
  const history = useHistory();
  const { voyNo } = useParams()

  const [bay, setBay] = useState(null)
  const [row, setRow] = useState(null)
  const [tier, setTier] = useState(null)
  const [table, setTable] = useState(null)
  const [dataC, setDataC] = useState([])
  const [loading, setLoading] = useState(true)


  function findBay(max, n) {
    if (max % 2 == 0) {
      if (n >= max / 2) {
        return (n - (max / 2)) * 2 + 1
      } else {
        return max - (n * 2)
      }
    } else {
      if (n >= (max - 1) / 2) {
        return (n - ((max - 1) / 2)) * 2 + 1
      } else {
        return (max - 1) - (n * 2)
      }
    }
  }

  const gentable = (bay, row, tier, dataC) => {
    let tbl = []
    let rows = [];
    let data = [];
    let size = dataC?.ContainerList?.filter((x) => x.Size === '40').map((x) => ({ ...x, Row: +x.Row + 1  }))
    dataC?.ContainerList?.push(...size)
    for (let t = 0; t < parseInt(tier); t++) {

      for (let r = 0; r <= parseInt(row); r++) {

        for (let b = 0; b <= parseInt(bay); b++) {
          if (b === 0 && r === 0) {
            data.push(<TableCell>r/b</TableCell>)
          } else if (b === 0 && r !== 0) {
            data.push(<TableCell align='center'>{r}</TableCell>)
          } else if (b !== 0 && r === 0) {
            data.push(<TableCell align='center'>{findBay(parseInt(bay), b - 1)}</TableCell>)
          } else {
            const item = dataC?.ContainerList?.filter((x) => `${x.Bay}${x.Row}${x.Tier}` === `${findBay(parseInt(bay), b - 1)}${r}${t + 1}`)

            data.push(<>
              <Tooltip arrow title={item?.length === 0 ? '' : `Container No. ${item?.map(x => (x?.ContainerId))}`} placement="top">
                <TableCell sx={{
                  background: item?.length === 0 ? '#00cf00' : item?.length === 1 ? '#0014ff' : '#ff0000', cursor: 'pointer', position: 'relative',
                  ':hover': {
                    WebKitFilter: 'grayscale(100%)',
                    filter: 'brightness(.5)'
                  }
                }}><Typography sx={{ opacity: '0' }}>999</Typography></TableCell>
              </Tooltip></>);

          }

        }

        rows.push(<><TableRow>{data}</TableRow></>);
        data = []
      }
      tbl.push(
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <TableContainer sx={{ padding: '20px', width: 'fit-content' }}>{rows}</TableContainer>
          <Typography>Tier / Floor: {t + 1}</Typography>
        </Box>);
      rows = []
    }
    setTable(tbl)
  }
  const getData = async () => {
    const res = await api.get(`api/ship/detail/planzone/${voyNo}`)
    const data = await res.data
    if (res.meta.status === true) {
      setDataC(data)
      setBay(data.Bay)
      setRow(data.Row)
      setTier(data.Tier)
      if (data.Bay && data.Row && data.Tier) {
        gentable(data.Bay, data.Row, data.Tier, data)
        setLoading(false)
      }
    }


  }
  useEffect(() => {
    getData()
  }, [])

  const handleSave = async () => {
    const body = {
      VoyNo: voyNo,
      Bay: bay,
      Row: row,
      Tier: tier
    }
    const res = await api.post(`api/ship/update/planzone`, body)
    const data = await res.data
    if (res.meta.status) {
      Swal.fire({
        title: `${res.meta.message}`,
        icon: 'success',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK',
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          getData()
        }
      })
    }
  }

  return (
    <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
      <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
        วางแผน
      </h6>

      <Grid container alignItems="center" spacing={1}>
        <Grid item xs>
          <Typography
            className="textcolordarkblue"
            variant="h5"
            component="h1"
          >
            PLAN #{voyNo}
          </Typography>
        </Grid>
        <Grid item sx={{ display: "flex", flexDirection: "row" }}>
          <Typography className="textcolorBule">
            ShipSchedule{" "}
          </Typography>
          <Typography>
            <span>&nbsp;</span> / Plan
          </Typography>
        </Grid>
      </Grid>
      <Grid
        //   container
        //   sx={{ justifyContent: "end" }}
        style={{ marginTop: "10px", display: "flex", flexDirection: 'column' }}
      >
        <Grid container>
          <Grid xs={3} sx={{ marginRight: "15px" }}>
            <TextField value={bay}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }} onChange={(e) => setBay(e.target.value)} InputLabelProps={{ shrink: true }}
              fullWidth label="Bay" variant="outlined" size='small' />
          </Grid>
          <Grid xs={3} sx={{ marginRight: "15px" }}>
            <TextField value={row}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }} onChange={(e) => setRow(e.target.value)} InputLabelProps={{ shrink: true }}
              fullWidth label="Row" variant="outlined" size='small' />
          </Grid>
          <Grid xs={3} sx={{ marginRight: "15px" }}>
            <TextField value={tier}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }} onChange={(e) => setTier(e.target.value)} InputLabelProps={{ shrink: true }}
              fullWidth label="Tier" variant="outlined" size='small' />
          </Grid>
          {/* <Grid xs={2} sx={{ marginRight: "15px" }}>
            <Button
              onClick={() => gentable(bay, row, tier, dataC)}
              variant='contained'
              disabled={bay && row && tier ? false : true}
              style={{
                color: bay && row && tier ? "#fff" : "#adb5bd",
                background: bay && row && tier ? "#80c340" : "#e9ecef",
                borderColor: bay && row && tier ? "#80c340" : "#e9ecef",
                marginRight: "10px",
              }}
            >
              confirms
            </Button>
          </Grid> */}
        </Grid>
        <Box
          sx={{
            width: "100%",
            marginTop: "10px",
            paddingBottom: "24px",
          }}
        >
          <Button
            type="button"
            variant="outlined"
            style={{
              color: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
            onClick={history.goBack}
          >
            back
          </Button>
          {bay && row && tier ? 
          <Button
            type="button"
            variant="contained"
            style={{
              color: "#fff",
              background: "#80c340",
              marginRight: "10px",
            }}
            onClick={handleSave}
          >
            save
          </Button>
          : null }

        </Box>

        <Box>
          {loading ? 'Loading...' : table}
        </Box>
      </Grid>
    </Card>
  )
}
